export interface Repository {
  id: string;
  name: string;
  url: string;
}

export const repositories: Repository[] = [
  {
    id: 'hub-api',
    name: 'API',
    url: 'https://github.com/veratrak/hub-api',
  },
  {
    id: 'hub-audit-service',
    name: 'Audit Service',
    url: 'https://github.com/veratrak/hub-audit-service',
  },
  {
    id: 'hub-blockchain-service',
    name: 'Blockchain Service',
    url: 'https://github.com/veratrak/hub-blockchain-service',
  },
  {
    id: 'hub-emissions',
    name: 'Emissions',
    url: 'https://github.com/veratrak/hub-emissions',
  },
  {
    id: 'hub-emissions-simulator',
    name: 'Emissions Simulator',
    url: 'https://github.com/veratrak/hub-emissions-simulator',
  },
  {
    id: 'hub-notification-service',
    name: 'Notification Service',
    url: 'https://github.com/veratrak/hub-notification-service',
  },
  {
    id: 'hub-transaction-apps',
    name: 'Transaction Apps',
    url: 'https://github.com/veratrak/hub-transaction-apps',
  },
];
